// @flow

import React from 'react';
import type { ResultItemContainerProps } from '../../../utils/types';
import { shape, string, array } from 'prop-types';

const DefaultItem = ({ result, translations }: ResultItemContainerProps) => {
  const {
    title,
    '@id': url,
    description,
    master_state,
    master_type,
    UID,
    year,
  } = result;
  return (
    <div className="course-item" key={UID}>
      <div className="mastercourse-infos">
        <div className="mastercourse-type">
          {master_type.map((master, i) => (
            <span key={`master-type-${i}`}>
              {master.title} {i < master_type.length - 1 ? ' - ' : ''}
            </span>
          ))}
        </div>
        <div className={'mastercourse-status ' + master_state.token}>
          <span>{master_state.title}</span>
        </div>
      </div>
      <div className="course-title">
        <a href={url} title={title}>
          <h2>{title.concat(year ? ` (${year})` : '')}</h2>
        </a>
      </div>
      {description && <div className="course-description">{description}</div>}
      <div className="course-footer">
        <a href={url} title={translations.search_readmore}>
          {translations.search_readmore || 'Read more'}
        </a>
      </div>
    </div>
  );
};

DefaultItem.propTypes = {
  result: shape({
    title: string,
    '@id': string,
    effective: string,
    description: string,
    UID: string,
    year: string,
    master_state: shape({ token: string }),
    master_type: array,
  }).isRequired,
  translations: shape({ search_readmore: string }),
};

export default DefaultItem;
